export default {
  data() {
    return {
      tenantId: this.realm,
      apiUrl: this.digitalTwinModelsListConfig.api,
    };
  },
  created() {
    this.getModelsList();
  },
  methods: {
    getModelsList() {
      this.loader = true;
      this.axios
        .get(this.apiUrl + "/" + this.tenantId + "/models", this.opts)
        .then((response) => {
          this.loader = false;
          this.models = response.data;
          document.dispatchEvent(new CustomEvent("hide-welcome-loader"));
        })
        .catch((err) => {
          this.loader = false;
          this.setError(err, true, "error-login-callback");
        });
    },
    getModelById(id) {
      this.loader = true;
      this.axios
        .get(this.apiUrl + "/" + this.tenantId + "/models/" + id, this.opts)
        .then((response) => {
          this.loader = false;
          sessionStorage.setItem(
            "digital-twin-model",
            JSON.stringify(response.data),
          );
          this.routeTo("/editor/summary");
        })
        .catch((err) => {
          this.loader = false;
          this.setError(err, true, "error-login-callback");
        });
    },

    deleteModel(item) {
      this.isMultipleItem = false;
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },
    deleteMultipleModel() {
      this.isMultipleItem = true;
      this.dialogDelete = true;
    },
    deleteModelConfirm() {
      this.isMultipleItem
        ? this.deleteMultipleModelConfirm()
        : this.deleteSingleModelConfirm();
    },
    async deleteSingleModelConfirm() {
      try {
        this.loader = true;
        await this.axios.delete(
          this.apiUrl +
            "/" +
            this.tenantId +
            "/models/" +
            this.editedItem.modelId,
          this.opts,
        );
        // Emit the snackbar event
        this.snackbarEvent(true, this.$t("strings.model-deleted"));
        // Wait for a short delay (e.g., 1 second) to allow the snackbar to display
        await new Promise((resolve) => setTimeout(resolve, 1500));

        this.getModelsList();
      } catch (error) {
        this.setError(error, false);
      } finally {
        this.loader = false;
        this.dialogDelete = false;
      }
    },
    async deleteMultipleModelConfirm() {
      try {
        this.loader = true;
        await this.axios.post(
          this.apiUrl + "/" + this.tenantId + "/models/deleteMany",
          this.selected,
          this.opts,
        );
        // Emit the snackbar event
        this.snackbarEvent(true, this.$t("strings.model-deleted"));
        // Wait for a short delay (e.g., 1 second) to allow the snackbar to display
        await new Promise((resolve) => setTimeout(resolve, 1500));

        this.getModelsList();
      } catch (error) {
        this.setError(error, false);
      } finally {
        this.loader = false;
        this.dialogDelete = false;
      }
    },

    snackbarEvent(value, text) {
      this.snackbar = value;
      this.snackbarText = text;
    },
    //Goes to a new path
    routeTo(newPath) {
      this.$router.push({
        path: newPath,
      });
    },
  },
};
